import { FC } from 'react';
import { IonSegment, IonSegmentButton } from '@ionic/react';
import { AllieSegmentProps } from './Segment.types';
import { AllieText } from '../Text';

export const AllieSegment: FC<AllieSegmentProps> = ({
  options,
  ...props
}) => (
  <IonSegment selectOnFocus swipeGesture={false} {...props}>
    {options.map(({ text, ...option }) => (
      <IonSegmentButton key={option.value} {...option}>
        <AllieText type='h5' weight={600}>{text}</AllieText>
      </IonSegmentButton>
    ))}
  </IonSegment>
);
